import axios from "axios"

export default{
    IntegrationInformation: {
        async Table(data){
            const response = await axios.post(`/api/company/integrationinformation/table`,data)
            return response
        },
        async Update(data){
            const response = await axios.post('/api/company/integrationinformation/update',data)
            return response
        },
        async GetById(id){
            const response = await axios.get(`/api/company/integrationinformation/get/${id}`)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/vehiclereferencemodel/delete/${id}`)
            return response
        },
        async CalculateTireCost(data){
            const response = await axios.post(`/api/vehiclereferencemodel/calculatetirecost`,data)
            return response
        },
        async List(){
            const response = await axios.get(`api/vehiclereferencemodel/select/list`)
            return response
        },
    },
    Branch:{
        async Table(data){
            const response = await axios.post(`/api/company/branch/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/company/branch/update' : '/api/company/branch/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/company/branch/delete/${data}`)
            return response
        },
        async Type(){
            const response = await axios.get(`/api/company/branchtype/select/list`)
            return response
        },
        async List(){
            const response = await axios.post(`api/company/branch/select/list`)
            return response
        },
        async ListByCode(type){
            const response = await axios.post(`api/company/branch/select/list?type=${type || null}`)
            return response
        },
    },
}